import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Dropdown from 'atoms/dropdown';
import {
  SELECTED_CALENDAR_VIEW_STORAGE_KEY,
  setCalendarView,
} from 'store/reducers/calendar';

export default function CalendarViewFilter() {
  const dispatch = useDispatch();
  const { view } = useSelector((state) => state.calendar);

  useEffect(() => {
    const storedSelectedView = localStorage.getItem(
      SELECTED_CALENDAR_VIEW_STORAGE_KEY
    );
    if (storedSelectedView) {
      dispatch(setCalendarView(JSON.parse(storedSelectedView)));
    }
  }, []);

  return (
    <Dropdown
      shape="round"
      variant="white"
      size="extra-small"
      onClick={(val) => dispatch(setCalendarView(val))}
      items={[
        { value: 'Daily', id: 'resourceTimeGridDay' },
        { value: 'Weekly', id: 'timeGridWeek' },
        { value: 'Monthly', id: 'dayGridMonth' },
      ]}
      value={view}
    />
  );
}
